<!-- eslint-disable max-len -->
<template>
  <div
    v-show="isVisible"
    class="modal-overlay">
    <div class="modal-box">
      <!-- 閉じるボタン -->
      <button
        class="close-button"
        @click="onClose">
        ✕
      </button>

      <div class="modal-content">
        <!-- 見出し -->
        <h2 class="modal-title">音源生成AIサービスの利用について</h2>

        <p class="description-text">
          一部の音源生成AIによって作成された楽曲には、他のアーティストの楽曲を元に生成されたものが含まれている場合があり、配信することで意図せず他のアーティストの著作権を侵害する可能性があります。<br>
          たとえご自身で生成された場合でも、権利上の問題が懸念される音源生成AIを使用した楽曲は、narasuでは配信できません。<br>
          配信可能な楽曲の範囲や禁止行為の詳細については、
          <router-link
            :to="{name: 'rules'}"
            class="c-text-link"
            @click.native="onLinkClick">
            配信規定ページ
          </router-link>
          をご確認ください。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'NarasuAIPopup',
  data() {
    return {
      isVisible: false,
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
  },
  mounted() {
    const stored = localStorage.getItem(`isShownNarasuAIPopup_${this.$store.state.auth.id}`)
    if (!stored) {
      this.isVisible = true
    }
  },
  methods: {
    onClose() {
      localStorage.setItem(`isShownNarasuAIPopup_${this.$store.state.auth.id}`, true)
      this.isVisible = false
    },
    onLinkClick() {
      localStorage.setItem(`isShownNarasuAIPopup_${this.$store.state.auth.id}`, true)
      this.isVisible = false
      this.$emit('click')
    },
  },
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.modal-box {
  background: white;
  border-radius: 10px;
  padding: 24px;
  width: 90%;
  max-width: 622px;
  position: relative;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}
.close-button {
  position: absolute;
  top: -12px;
  right: -12px;
  background: #007bff;
  border: none;
  color: white;
  font-size: 18px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  cursor: pointer;
}

.modal-title {
  font-weight: bold;
  font-size: 26px;
  margin-bottom: 16px;
  text-align: center;
}
.modal-body {
  font-size: 14px;
  color: #333;
  line-height: 2;
  margin-bottom: 20px;

  /* スクロール対応・見た目の調整 */
  border: 1px solid #000;
  padding: 12px;
  max-height: 290px;
  overflow-y: auto;
  background-color: #fff;
}
.modal-footer {
  display: flex;
  justify-content: space-around;
}
.btn-decline {
  flex: 1;
  margin-left: 10px;
  padding: 10px;
  /* background-color: oklch(70.8% 0 0); */
  color: white;
  border: none;
  border-radius: 50px;
  font-weight: 500;
  cursor: pointer;
}

.btn-agree_narasu {
  flex: 1;
  margin-right: 10px;
  padding: 10px;
  /* narasuのテーマカラー */
  background-color: #ff2289;
  color: white;
  border: none;
  border-radius: 50px;
  font-weight: 500;
  cursor: pointer;
}

.btn-agree_zu_map {
  flex: 1;
  margin-right: 10px;
  padding: 10px;
  /* narasuのテーマカラー */
  background-color: rgb(255, 108, 0);
  color: white;
  border: none;
  border-radius: 50px;
  font-weight: 500;
  cursor: pointer;
}

.description-text {
  font-size: 16px;
}
@media (max-width: 895px) {
  .modal-box {
    width: 90%;
    max-height: 95vh;
    padding: 10px;
  }

  .modal-title {
    font-size: 14px;
    text-align: left;
    margin-bottom: 0;
    margin-top: 0;
  }

  .modal-footer {
    margin-top: 8px;
    display: flex;
    justify-content: space-around;
  }

  .btn-decline,
  .btn-agree_zu_map,
  .btn-agree_narasu {
    font-size: 12px;
    font-weight: 500;
    width: 40%;
    margin-bottom: 12px;
  }

  .close-button {
    padding: 0;
    position: absolute;
    top: -10px;
    right: -10px;
    width: 24px;
    height: 24px;
    background: #007bff;
    border: none;
    color: white;
    font-size: 18px;
    border-radius: 50%;
    cursor: pointer;
  }
  .modal-content {
    overflow-y: scroll;
    max-height: 95vh;
  }
  .description-text {
    font-size: 12px;
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>
<style lang="scss" scoped>
  ol.numbered{
    margin-left: 1.2em;
    & > li{
    list-style: decimal;
      }
  }
</style>
